import { useMemo } from "react";
import type { ExcursionCardProps } from "@op/puck-types";
import { cls, clx, useTranslation } from "@op/utils";

const ExcursionCardWzb = ({
  excursion,
  isMarginal,
  variant,
}: ExcursionCardProps) => {
  const { excursionCard } = useTranslation();

  const actualVariant = useMemo(() => {
    switch (variant) {
      case "primary":
        return "brand";
      case "secondary":
        return "brandsecondary";
      case "tertiary":
        return "brandtertiary";
    }
  }, [variant]);

  return (
    <a href={`#${excursion.slug}`}>
      <div
        className={cls(
          "cursor-pointer transition-colors",
          clx({
            "h-full": !isMarginal,
            "bg-brand-50 hover:bg-brand-100": actualVariant === "brand",
            "bg-brandsecondary-50 hover:bg-brandsecondary-100":
              actualVariant === "brandsecondary",
            "bg-brandtertiary-50 hover:bg-brandtertiary-100":
              actualVariant === "brandtertiary",
          }),
        )}
      >
        <div
          className={cls(
            "w-full",
            "h-1",
            "mb-6",
            clx({
              "bg-brand-500": actualVariant === "brand",
              "bg-brandsecondary-500": actualVariant === "brandsecondary",
              "bg-brandtertiary-500": actualVariant === "brandtertiary",
            }),
          )}
        />
        <div className={cls("inline-block p-4")}>
          <span
            className={cls(
              "text-caption-bold font-caption-bold comp-excursion-card-title inline-block",
              clx({
                "text-brand-700": actualVariant === "brand",
                "text-brandsecondary-700": actualVariant === "brandsecondary",
                "text-brandtertiary-700": actualVariant === "brandtertiary",
              }),
            )}
          >
            {excursionCard.see} {excursion.overline}
          </span>
          <div
            className={cls(
              "comp-excursion-card-title inline-block text-[14px] leading-[1.25em] font-heading-4",
              clx({
                "!text-brand-700": actualVariant === "brand",
                "!text-brandsecondary-700": actualVariant === "brandsecondary",
                "!text-brandtertiary-700": actualVariant === "brandtertiary",
              }),
            )}
          >
            {excursion.title}
          </div>
        </div>
      </div>
    </a>
  );
};

export default ExcursionCardWzb;
